import React from "react"

const WhiteDropdownIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 8L10.5 12.5L15 8" stroke="#FFFFFF" stroke-width="1.5" />
        </svg>

    )
}
export default WhiteDropdownIcon